import {
  GateDirection,
  LayoutObjectDto,
  LayoutObjectType,
  UpdateLayoutObjectRequest,
} from '@yard/app/api'
import { ILayoutObjectFormData } from '../models/yard-setup.model'
import {
  GATE_HEIGHT,
  GATE_WIDTH,
  HANDOVER_AREA_HEIGHT,
  HANDOVER_AREA_WIDTH,
  HOLDING_POINT_HEIGHT,
  HOLDING_POINT_WIDTH,
  LAYOUT_OBJECT_HEIGHT,
  LAYOUT_OBJECT_WIDTH,
} from './yard-view.utils'

export type CreateLayoutObjectRequest = {
  name: string
  width: number
  height: number
  type: LayoutObjectType
  positionX?: number
  positionY?: number
  positionRotation?: number
  image?: File
  description?: string
  color?: string
  opacity?: number
  code?: string
  direction?: GateDirection
  active?: boolean
}

const getDefaultDimensions = (type: LayoutObjectType): { width: number; height: number } => {
  switch (type) {
    case LayoutObjectType.Gate:
      return { width: GATE_WIDTH, height: GATE_HEIGHT }
    case LayoutObjectType.HoldingPoint:
      return { width: HOLDING_POINT_WIDTH, height: HOLDING_POINT_HEIGHT }
    case LayoutObjectType.HandoverArea:
      return { width: HANDOVER_AREA_WIDTH, height: HANDOVER_AREA_HEIGHT }
    default:
      return { width: LAYOUT_OBJECT_WIDTH, height: LAYOUT_OBJECT_HEIGHT }
  }
}

export const mapLayoutObjectFormDataToCreateCommand = (
  data: ILayoutObjectFormData,
  type: LayoutObjectType,
  position?: { x: number; y: number },
) => {
  const { width, height } = getDefaultDimensions(type)

  const isGate = type === LayoutObjectType.Gate

  const command: CreateLayoutObjectRequest = {
    name: data.name,
    height,
    width,
    positionX: Math.round(position?.x ?? 0),
    positionY: Math.round(position?.y ?? 0),
    positionRotation: 0,
    type: type,
    image: data.file,
    description: data.description,
    color: data.color,
    opacity: data.opacity !== undefined ? data.opacity / 100 : undefined,
    code: isGate ? data.code : undefined,
    direction: isGate ? (data.direction ?? GateDirection.Both) : undefined,
    active: isGate ? (data.active ?? true) : undefined,
  }

  return command
}

export const mapLayoutObjectFormDataToUpdateCommand = (
  data: ILayoutObjectFormData,
  layoutObject: LayoutObjectDto,
) => {
  const isGate = layoutObject.type === LayoutObjectType.Gate

  const command: UpdateLayoutObjectRequest = {
    id: layoutObject.id,
    name: data.name,
    height: layoutObject.height,
    width: layoutObject.width,
    position: {
      x: layoutObject.layoutPosition.x,
      y: layoutObject.layoutPosition.y,
      rotation: layoutObject.layoutPosition.rotation,
    },
    description: data.description,
    color: data.color,
    opacity: data.opacity !== undefined ? data.opacity / 100 : undefined,
    code: isGate ? data.code : undefined,
    direction: isGate ? (data.direction ?? GateDirection.Both) : undefined,
    active: isGate ? (data.active ?? true) : undefined,
  }

  return command
}
